import { api } from '../apiClient'

export interface MyProfile {
  id: string
  email?: string
  phone?: string
  postcode?: string
  plan: 'free' | 'pro'
  createdAt: string
  lastLogin?: string
  deleteRequestedAt: string | null
  deleteScheduledFor: string | null
}

export interface MyJob {
  _id: string
  jobRef: string
  status: string
  createdAt: string
  confirmedAt?: string
  completedAt?: string
  selectedPlumber?: { companyName?: string; calloutFee?: number }
  customer: { postcode: string; issueDescription: string }
  payment?: { platformFee?: number; status?: string }
  outreachChannel?: 'call' | 'sms'
}

export async function getMe(): Promise<MyProfile> {
  const res = await api.get('/api/me')
  return res.data
}

export async function getMyJobs(): Promise<{ jobs: MyJob[] }> {
  const res = await api.get('/api/me/jobs')
  return res.data
}

export async function openBillingPortal(): Promise<{ url: string }> {
  const res = await api.post('/api/me/billing-portal')
  return res.data
}

export async function requestAccountDeletion(reason?: string): Promise<{ ok: boolean; deleteScheduledFor?: string; alreadyRequested?: boolean }> {
  const res = await api.post('/api/me/delete', reason ? { reason } : {})
  return res.data
}

export async function cancelAccountDeletion(): Promise<{ ok: boolean; cancelled: boolean }> {
  const res = await api.post('/api/me/delete/cancel')
  return res.data
}
